// Servers admin (R-152) — cloud + admin only. Boxes phone home; claim/manage them here.
// DE drafted — queued for native review.
export const servers = {
  title: { de: 'Server', en: 'Servers' },
  desc: {
    de: 'Lokale Server, die sich beim Cloud-Server gemeldet haben. Nicht zugewiesene beanspruchen (Name/Code), aktivieren/deaktivieren, Adresse aktualisieren.',
    en: 'Local servers that have phoned home. Claim an unclaimed one (name/code), enable/disable, or refresh its address.',
  },
  colStatus: { de: 'Status', en: 'Status' },
  colAddress: { de: 'Adresse', en: 'Address' },
  colHost: { de: 'Host', en: 'Host' },
  colSite: { de: 'Standort', en: 'Site' },
  colSeen: { de: 'Zuletzt gesehen', en: 'Last seen' },

  online: { de: 'online', en: 'online' },
  offline: { de: 'offline', en: 'offline' },
  disabled: { de: 'deaktiviert', en: 'disabled' },
  unclaimed: { de: 'Nicht zugewiesen', en: 'Unclaimed' },

  claim: { de: 'Beanspruchen', en: 'Claim' },
  enable: { de: 'Aktivieren', en: 'Enable' },
  disable: { de: 'Deaktivieren', en: 'Disable' },
  refresh: { de: 'Adresse aktualisieren', en: 'Refresh address' },
  remove: { de: 'Entfernen', en: 'Remove' },
  removeConfirm: { de: 'Diese Server-Registrierung entfernen?', en: 'Remove this server registration?' },
  // ⚠ Removing a CLAIMED row deletes the site too, and the old wording ('this server
  // registration') never said so — one click away from deleting a live farm's cloud
  // config. The site is named in the question because that is the thing being lost.
  removeSiteConfirm: {
    de: 'Server und Standort „{site}“ entfernen? Der Standort und seine Cloud-Konfiguration werden gelöscht.',
    en: 'Remove this server and the site \u201c{site}\u201d? The site and its cloud configuration are deleted.',
  },
  // A second registration still holding the same site is a ghost of the same box under
  // an old instance id. Removing it must NOT take the site the live box is serving.
  removeDupConfirm: {
    de: 'Diese veraltete Registrierung entfernen? Der Standort „{site}“ wird von einem anderen Server bedient und bleibt bestehen.',
    en: 'Remove this stale registration? The site \u201c{site}\u201d is served by another server and is kept.',
  },
  // Says what disabling actually DOES. `disabled_site_ids` is read by the health
  // classifier AND by the alarm watcher AND by the heartbeat monitor, so this
  // suppresses monitoring — the farm keeps running and controlling hardware, but
  // the cloud stops telling you when something is wrong. "Marked offline" hid that.
  disableConfirm: {
    de: 'Diesen Server deaktivieren? Überwachung und Alarme für diesen Standort werden ausgesetzt — der Standort läuft weiter, aber du wirst nicht mehr benachrichtigt, wenn etwas schiefgeht.',
    en: 'Disable this server? Monitoring and alarms for this site are suspended — the site keeps running and controlling its hardware, but you will stop being told when something goes wrong.',
  },
  enableConfirm: { de: 'Diesen Server wieder aktivieren?', en: 'Re-enable this server?' },

  claimTitle: { de: 'Server beanspruchen', en: 'Claim server' },
  claimIntro: {
    de: 'Legt einen Standort an dieser Adresse an und verknüpft den Server. Er übernimmt seine Identität bei der nächsten Meldung — kein Neustart.',
    en: 'Creates a site at this address and links the server. It adopts its identity on the next announce — no restart.',
  },
  fieldName: { de: 'Name', en: 'Name' },
  fieldCode: { de: 'Code', en: 'Code' },
  codeHint: {
    de: 'Leer lassen — der Code wird aus dem Namen erzeugt („Some Site" → SS) und ist danach dauerhaft.',
    en: 'Leave blank — the code is derived from the name (“Some Site” → SS), and is permanent once set.',
  },

  emptyTitle: { de: 'Noch keine Server', en: 'No servers yet' },
  emptyMsg: {
    de: 'Starten Sie einen lokalen Server mit CLOUD_REGISTER_URL — er meldet sich hier und kann dann beansprucht werden.',
    en: 'Start a local server with CLOUD_REGISTER_URL set — it phones home here and can then be claimed.',
  },
  loadError: { de: 'Server konnten nicht geladen werden', en: 'Could not load servers' },

  toastClaimed: { de: 'Server beansprucht', en: 'Server claimed' },
  toastStatus: { de: 'Status geändert', en: 'Status changed' },
  toastRefreshed: { de: 'Adresse aktualisiert', en: 'Address refreshed' },
  toastRemoved: { de: 'Server entfernt', en: 'Server removed' },
} as const;
